import api from "@/api";

const state = () => ({
  data: null,
});

const actions = {
  async fetch({ commit, dispatch }) {
    const data = await api({ url: "/123/products/popular" });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : commit("UPDATE", data.info);
  },
};

const getters = {
  popular({ data }) {
    if (!data) {
      return;
    }
    return data.length;
  },
};

const mutations = {
  UPDATE(state, products) {
    state.data = products;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
